import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Theme Color Meta Tag"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "theme-color-meta-tag"
    }}>{`Theme Color Meta Tag`}</h1>
    <p>{`Use your framework’s method of adding a meta tag to `}<inlineCode parentName="p">{`<head />`}</inlineCode>{`—`}<a parentName="p" {...{
        "href": "https://github.com/nfl/react-helmet"
      }}><inlineCode parentName="a">{`react-helmet`}</inlineCode></a>{` in Gatsby and `}<a parentName="p" {...{
        "href": "https://nextjs.org/docs/api-reference/next/head"
      }}><inlineCode parentName="a">{`next/head`}</inlineCode></a>{` in Next.js, for example.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// example Head component with react-helmet
import { Helmet } from 'react-helmet'
import { useThemeUI } from 'theme-ui'

export default (props) => {
  const { theme } = useThemeUI()

  return (
    <Helmet>
      <meta name="theme-color" content={theme.colors.primary} />
    </Helmet>
  )
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      